import { render } from "./CulturePoint.vue?vue&type=template&id=b905e5b2"
import script from "./CulturePoint.vue?vue&type=script&lang=js"
export * from "./CulturePoint.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/pages/villageOverview/CulturePoint.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "b905e5b2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('b905e5b2', __exports__)) {
    api.reload('b905e5b2', __exports__)
  }
  
  module.hot.accept("./CulturePoint.vue?vue&type=template&id=b905e5b2", () => {
    api.rerender('b905e5b2', render)
  })

}


export default __exports__